import React, { createContext, useContext, useState } from 'react';

const NumberFormatContext = createContext(null);

export const FORMAT_OPTIONS = [
  { key: 'crores',   label: 'Cr', description: 'Crores  — ₹1.50Cr' },
  { key: 'lakhs',    label: 'L',  description: 'Lakhs   — ₹150.00L' },
  { key: 'absolute', label: '₹',  description: 'Absolute — ₹1,50,00,000' },
];

export const NumberFormatProvider = ({ children }) => {
  const [format, setFormatState] = useState(
    () => localStorage.getItem('salty_num_format') || 'crores'
  );

  const setFormat = (fmt) => {
    setFormatState(fmt);
    localStorage.setItem('salty_num_format', fmt);
  };

  return (
    <NumberFormatContext.Provider value={{ format, setFormat }}>
      {children}
    </NumberFormatContext.Provider>
  );
};

export const useNumberFormat = () => {
  const ctx = useContext(NumberFormatContext);
  if (!ctx) throw new Error('useNumberFormat must be used within NumberFormatProvider');
  return ctx;
};

/**
 * Format a rupee value according to the user's chosen display format.
 * @param {number} value   — raw rupee value
 * @param {string} format  — 'crores' | 'lakhs' | 'absolute'
 * @param {number} decimals — decimal places (default 2)
 */
export function applyFormat(value, format, decimals = 2) {
  if (value === null || value === undefined || isNaN(value)) return '₹0';
  const abs  = Math.abs(value);
  const sign = value < 0 ? '-' : '';

  switch (format) {
    case 'crores':
      return `${sign}₹${(abs / 10000000).toFixed(decimals)}Cr`;
    case 'lakhs':
      return `${sign}₹${(abs / 100000).toFixed(decimals)}L`;
    case 'absolute':
    default:
      return `${sign}₹${abs.toLocaleString('en-IN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: decimals,
      })}`;
  }
}
